<div class="content-width advertisment-wrapper">
    <div class="advertisment">
        <ion-text color="medium">
            Advertisment
        </ion-text>
    </div>
    <ion-card (click)="openLink()">
        <div class="flex-container">
            <div class="flex-item-left {{themeService.isDarkMode ? 'dark': 'light'}}">
                Done with College Tennis?<br />
                Your Pro Journey Starts Here.<br />
                Find Out How – Join the Free Webinar
            </div>
            <div class="flex-item-right">
                <figure>
                    <img src="/assets/img/intennse-ad.png" alt="">
                </figure>
            </div>
        </div>
    </ion-card>
</div>